import { render } from "./TaikyoNotificationFlowGuidePage.vue?vue&type=template&id=6a54ca98&scoped=true&ts=true"
import script from "./TaikyoNotificationFlowGuidePage.vue?vue&type=script&lang=ts"
export * from "./TaikyoNotificationFlowGuidePage.vue?vue&type=script&lang=ts"

import "./TaikyoNotificationFlowGuidePage.vue?vue&type=style&index=0&id=6a54ca98&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6a54ca98"]])

export default __exports__
import QPage from 'quasar/src/components/page/QPage.js';
import QCard from 'quasar/src/components/card/QCard.js';
import QCardSection from 'quasar/src/components/card/QCardSection.js';
import QSeparator from 'quasar/src/components/separator/QSeparator.js';
import QChip from 'quasar/src/components/chip/QChip.js';
import QAvatar from 'quasar/src/components/avatar/QAvatar.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QCardActions from 'quasar/src/components/card/QCardActions.js';
import qInstall from "../../../../node_modules/@quasar/app-webpack/lib/loaders/runtime.auto-import.js";
qInstall(script, 'components', {QPage,QCard,QCardSection,QSeparator,QChip,QAvatar,QBtn,QCardActions});
